survey_handler = {

    properties: {
        completed: false
    },

    onLoad: function(){
        var self = this;

        if (self.properties.completed){
          window.location.href = "#/complete/";  
        }

        $('#content-root, #map').removeClass('swipe');
        $('#content-root').addClass('large secondary-bg background-img');

    },

    formSubmit: function(event) {

        var self = this;
        $('#submit').prop('disabled', true);
        var fd = new FormData();  
        var checkedItems = function(divName){
            var selected = [];
            $('#' + divName + ' input:checked').each(function() {

                var name = $(this).val();
                selected.push(name);
            });
            return JSON.stringify(selected);
        }

        var formData = {
            'q1': $('input[name=q1]:checked').val(),
            'q2': checkedItems('q2'),
            'q3': $('input[name=q3]:checked').val(),
            'q4': $('input[name=q4]:checked').val(),
            'q5': $('input[name=q5]:checked').val(),
            'q6': $('input[name=q6]:checked').val(),
            'q7': $('input[name=q7]:checked').val(),
            'q8': $('input[name=q8]:checked').val(),
            'q9': checkedItems('q9'),
            'q10': $('input[name=q10]:checked').val(),
            'q11': checkedItems('q11'),
            'q12': $('input[name=q12]:checked').val() || '',
            'q4o': $('textarea[name=q4other]').val() || '',
            'q5o': $('textarea[name=q5other]').val() || '',
            'q6o': $('textarea[name=q6other]').val() || '',
            'q7o': $('textarea[name=q7other]').val() || '',
            'q9o': $('input[name=q9other]').val() || '',
            'email': $('input[name=email]').val() || '',
        };

        $.each(formData, function(key, value)
        {
            fd.append(key, value);
        });

        $.ajax({
            type: "POST",
            url: mapData.surveyURL,
            processData: false,
            contentType: false,
            crossDomain: false,
            data: fd,
            success: function(json) {
                $('#submit').prop('disabled', false);
                if (json.error) {
                    alert('Unable to complete your request at this time.');
                } else {
                    mapData.drawnItemsLayer.clearLayers();
                    survey_handler.properties.completed = true; 
                    window.location.href = "#/complete/";
                }
            },
            error: function(xhr, textStatus, errorThrown) {
                $('#submit').prop('disabled', false);
                alert('error');
            }
        });
        event.preventDefault();
    },

    updateStatus: function(next){
        var statusItem = $('.survey-status-item');
        $.each(statusItem, function(index, value)
        {
            $(value).children('img').attr('src', 'img/survey-item.png');
        });
        $.each(statusItem, function(index, value)
        {
            if ($(value).attr('for') == next){
                $(value).children('img').attr('src', 'img/survey-active.png');
                return false;
            }
            $(value).children('img').attr('src', 'img/survey-complete.png');
        });
    },


    events: function() {
        var self = this;
        self.onLoad();

        $(".suggestion-submit").submit(function(event) {
            var next = $(this).attr('next');
            var id = $(this).attr('id');

            if (next !== "submit"){
                if (id == "q2"){
                    if ($('#q2 input:checked').length > 2){
                        alert("Please only two options.");
                        return false;
                    }
                }

                $('.suggestion-submit').addClass('hidden').removeClass('animated fadeIn');
                $('#'+next).removeClass('hidden').addClass('animated fadeIn');
                self.updateStatus(next);
            }
            else{
                self.formSubmit(event);
            }
            
            event.preventDefault();
        });

        $(".next-q").click(function(event) {
            var next = $(this).attr('next');
            $('.suggestion-submit').addClass('hidden').removeClass('animated fadeIn');
            $('#'+next).removeClass('hidden').addClass('animated fadeIn');
            self.updateStatus(next);
            return false;
        });

        //Select Other on Other input change.
        $('.othertxt').on('input', function(e) {
            var other = $(this).attr('other');
            $('#' + other).prop('checked', true);
        });

        $('.rendering-popup').click(function(event) {

            $("#rendering-info").modal({
                clickClose: true
            });

            return false;
        });


    }
}
